/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約検索情報
 */
export interface Szma202aRequestCtrSearchInfo {
    /**
     * 契約お客さま番号：数字
     */
    firstSrvctrNo: string;
    /**
     * 算定期間（ＦＲＯＭ）：日付(yyyyMMdd)
     */
    calcStartDate: string;
    /**
     * 算定期間（ＴＯ）：日付(yyyyMMdd)
     */
    calcEndDate: string;
}

